import * as CookieConsent from 'vanilla-cookieconsent';

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */

CookieConsent.run({
    guiOptions: {
        consentModal: {
            layout: 'bar inline',
            position: 'bottom',
            equalWeightButtons: true,
            flipButtons: false,
        },
        preferencesModal: {
            layout: 'box',
            position: 'right',
            equalWeightButtons: true,
            flipButtons: false,
        },
    },
    categories: {
        necessary: {
            readOnly: true,
        },
        analytics: {},
    },
    language: {
        default: 'fr-CA',
        autoDetect: 'document',
        translations: {
            'en-CA': {
                consentModal: {
                    description: 'We place great importance on the protection of your privacy. Our data collection practices are governed by a transparent Privacy Policy. By browsing this site, you consent to the use of cookies and other technologies to enhance your experience and analyze site usage. You have the option to manage your preferences by customizing site or browser settings. You can also adjust your choice at any time by clicking the "Manage Cookie Preferences" link located in the footer.',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    showPreferencesBtn: 'Manage preferences',
                },
                preferencesModal: {
                    title: 'Cookie preferences',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Save preferences',
                    closeIconLabel: 'Close modal',
                    serviceCounterLabel: 'Service|Services',
                    sections: [
                        {
                            title: null,
                            description: 'We use cookies to help you navigate efficiently and perform certain functions. Detailed information about all cookies can be found under each consent category below. <br><br>You can choose to enable or disable these cookies in whole or in part. However, please note that disabling some of them may impact your browsing experience.',
                        },
                        {
                            title: 'Necessary cookies <span class="pm__badge">Always Enabled</span>',
                            description: 'Cookies categorized as "necessary" are stored on your browser and are essential for the basic functionalities of the site. Crucial for the proper functioning of the site, necessary cookies do not store any personally identifiable information.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Name',
                                    description: 'Description',
                                    domain: 'Domain',
                                    expiration: 'Expiration',
                                },
                                body: [
                                    {
                                        name: 'cart',
                                        description: 'This cookie contains the data from your shopping cart, allowing you to add items and place an order.',
                                        domain: window.location.hostname,
                                        expiration: '1 year',
                                    },
                                    {
                                        name: 'cmeq_recent_search',
                                        description: 'This cookie contains the information you searched for using the search tool.',
                                        domain: window.location.hostname,
                                        expiration: 'Session',
                                    },
                                    {
                                        name: 'fe_typo_user',
                                        description: 'This cookie contains information related to the user account you are logged into.',
                                        domain: window.location.hostname,
                                        expiration: 'Session',
                                    },
                                    {
                                        name: 'ps_n',
                                        description: 'This cookie is set by Facebook to deliver advertisement when they are on Facebook or a digital platform powered by Facebook advertising after visiting this website.',
                                        domain: 'facebook.com',
                                        expiration: '1 year',
                                    },
                                ],
                            },
                        },
                        {
                            title: 'Optional cookies',
                            description: 'We use third-party cookies to analyze your usage of the site. Analytics cookies provide information about visitor interactions, including the number, bounce rate, traffic source, etc. These cookies will only be stored in your browser with your prior consent.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Nom',
                                    description: 'Description',
                                    domain: 'Domaine',
                                    expiration: 'Expiration',
                                },
                                body: [
                                    {
                                        name: '_fbp',
                                        description: 'This cookie is set by Facebook to deliver advertisement when they are on Facebook or a digital platform powered by Facebook advertising after visiting this website.',
                                        domain: 'facebook.com',
                                        expiration: '3 months',
                                    },
                                    {
                                        name: '_ga',
                                        description: "This cookie is installed by Google Analytics. The cookie is used to calculate visitor, session, campaign data and keep track of site usage for the site's analytics report. The cookies store information anonymously and assigns a randomly generated number to identify unique visitors.",
                                        domain: 'google.com',
                                        expiration: '2 years',
                                    },
                                    {
                                        name: '_gat_*',
                                        description: 'This cookie is used by Google Analytics to throttle request rate.',
                                        domain: 'google.com',
                                        expiration: '1 minute',
                                    },
                                    {
                                        name: '_gid',
                                        description: 'This cookie is installed by Google Analytics. The cookie is used to store information of how visitors use a website and helps in creating an analytics report of how the website is doing. The data collected includes the number of visitors, the source where they have come from, and the pages visited in an anonymous form.',
                                        domain: 'google.com',
                                        expiration: '1 day',
                                    },
                                    {
                                        name: '_hjSessionUser_*',
                                        description: 'This cookie is set when a user first lands on a page with the Hotjar script. It is used to persist the Hotjar User ID, unique to that site on the browser. This ensures that behaviour in subsequent visits to the same site will be attributed to the same user ID.',
                                        domain: 'hotjar.com',
                                        expiration: '1 year',
                                    },
                                    {
                                        name: '_hjSession_*',
                                        description: 'This cookie holds the current session data. This ensues that subsequent requests within the session window will be attributed to the same Hotjar session.',
                                        domain: 'hotjar.com',
                                        expiration: '30 minutes',
                                    },
                                ],
                            },
                        },
                    ],
                },
            },
            'fr-CA': {
                consentModal: {
                    description: "Nous attachons une grande importance à la protection de votre vie privée. Nos pratiques de collecte de données sont régies par une Politique de confidentialité transparente. En naviguant sur ce site, vous consentez à l'utilisation de témoins (cookies) et d'autres technologies pour améliorer votre expérience et analyser l'utilisation du site. Vous avez la possibilité de gérer vos préférences en personnalisant les paramètres du site ou de votre navigateur. Vous pouvez également ajuster votre choix à tout moment en cliquant sur le lien \"Gestion des témoins de navigation\", situé dans le pied de page.",
                    acceptAllBtn: 'Tout accepter',
                    acceptNecessaryBtn: 'Tout rejeter',
                    showPreferencesBtn: 'Gérer les préférences',
                },
                preferencesModal: {
                    title: 'Personnaliser vos préférences en matière de consentement',
                    acceptAllBtn: 'Tout accepter',
                    acceptNecessaryBtn: 'Tout rejeter',
                    savePreferencesBtn: 'Sauvegarder les préférences',
                    closeIconLabel: 'Fermer la modale',
                    serviceCounterLabel: 'Services',
                    sections: [
                        {
                            title: null,
                            description: "Nous utilisons des témoins (cookies) pour vous aider à naviguer efficacement et à exécuter certaines fonctionnalités. Vous trouverez des informations détaillées sur tous les cookies sous chaque catégorie de consentement ci-dessous. <br><br>Vous pouvez choisir d'activer tout ou de désactiver en partie ces témoins. Toutefois, veuillez noter que la désactivation de certains d'entre eux pourrait avoir un impact sur votre expérience de navigation. ",
                        },
                        {
                            title: 'Témoins obligatoires <span class="pm__badge">Toujours Activé</span>',
                            description: 'Les témoins catégorisés comme "obligatoires" sont stockés sur votre navigateur et sont essentiels pour les fonctionnalités de base du site. Cruciaux pour le bon fonctionnement du site, les témoins nécessaires ne stockent aucune donnée personnellement identifiable.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Nom',
                                    description: 'Description',
                                    domain: 'Domaine',
                                    expiration: 'Expiration',
                                },
                                body: [
                                    {
                                        name: 'cart',
                                        description: "Ce témoin contient les données de votre panier d'achat, permettant d'ajouter des articles et passer une commande.",
                                        domain: window.location.hostname,
                                        expiration: '1 an',
                                    },
                                    {
                                        name: 'cmeq_recent_search',
                                        description: "Ce témoin contient les informations que vous avez cherchées dans l'outil de recherche.",
                                        domain: window.location.hostname,
                                        expiration: 'Session',
                                    },
                                    {
                                        name: 'fe_typo_user',
                                        description: 'Ce témoin contient les informations liées au compte utilisateur auquel vous êtes connecté.',
                                        domain: window.location.hostname,
                                        expiration: 'Session',
                                    },
                                    {
                                        name: 'ps_n',
                                        description: 'Ce témoin est défini par Facebook pour diffuser des publicités lorsque les utilisateurs se trouvent sur Facebook ou sur une plateforme numérique alimentée par la publicité Facebook, après avoir visité ce site web.',
                                        domain: 'facebook.com',
                                        expiration: '1 an',
                                    },
                                ],
                            },
                        },
                        {
                            title: 'Témoins facultatifs',
                            description: "Nous utilisons des témoins tiers pour analyser votre utilisation du site. Les témoins facultatifs fournissent des informations sur les interactions des visiteurs, notamment le nombre, le taux de rebond, la source de trafic, etc. Ces témoins ne seront stockés dans votre navigateur qu'avec votre consentement préalable.",
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Nom',
                                    description: 'Description',
                                    domain: 'Domaine',
                                    expiration: 'Expiration',
                                },
                                body: [
                                    {
                                        name: '_fbp',
                                        description: 'Ce témoin est défini par Facebook pour diffuser des publicités lorsque les utilisateurs se trouvent sur Facebook ou sur une plateforme numérique alimentée par la publicité Facebook, après avoir visité ce site web.',
                                        domain: 'facebook.com',
                                        expiration: '3 mois',
                                    },
                                    {
                                        name: '_ga',
                                        description: 'Google Analytics utilise ce témoin pour calculer les données relatives aux visiteurs, aux sessions et aux campagnes. Le témoin permet de suivre l’utilisation du site pour le rapport d’analyse du site. Il stocke les informations de manière anonyme et attribue un numéro généré de manière aléatoire pour identifier les visiteurs uniques.',
                                        domain: 'google.com',
                                        expiration: '2 ans',
                                    },
                                    {
                                        name: '_gat_*',
                                        description: 'Ce témoin est utilisé par Google Analytics pour réguler le taux de requêtes.',
                                        domain: 'google.com',
                                        expiration: '1 minute',
                                    },
                                    {
                                        name: '_gid',
                                        description: "Ce témoin est installé par Google Analytics. Il sert à stocker des informations sur la façon dont les visiteurs utilisent un site web et aide à créer un rapport analytique sur les performances du site. Les données recueillies incluent le nombre de visiteurs, leur source d'origine, ainsi que les pages visitées, le tout de manière anonyme.",
                                        domain: 'google.com',
                                        expiration: '1 jour',
                                    },
                                    {
                                        name: '_hjSessionUser_*',
                                        description: "Ce témoin est défini lorsqu'un utilisateur arrive pour la première fois sur une page contenant le script Hotjar. Il sert à conserver l'identifiant utilisateur Hotjar, unique à ce site, dans le navigateur. Cela assure que le comportement lors de visites ultérieures sur le même site sera attribué au même identifiant utilisateur.",
                                        domain: 'hotjar.com',
                                        expiration: '1 an',
                                    },
                                    {
                                        name: '_hjSession_*',
                                        description: 'Ce témoin contient les données de la session en cours, garantissant ainsi que les requêtes ultérieures dans la fenêtre de session seront attribuées à la même session Hotjar.',
                                        domain: 'hotjar.com',
                                        expiration: '30 minutes',
                                    },
                                ],
                            },
                        },
                    ],
                },
            },
        },
    },
});
